/* ランキングタブをクリックで同じindexのランキング一覧表示を切り替える関数
 * parentNameから' .js-ranking-tabs > li' を拾ってクラス名acitveのadd/remove
 * クリックしたtabのindexに合わせて'.js-ranking-lists > .js-ranking-list' のindexにクラス名activeのadd/remove
 * tabの背景アニメーションのため、tabBackgroundのtabの幅を取得と、アニメーションを追加
 *
 * @params {string} parentClassName トグルの対象になる'.js-ranking-tabs > li'と'.js-ranking-lists > ul'がある親要素
 * @params {boolean} usingParamFlg ページロード時にURLパラメータから表示を切り替える必要があるかどうかのフラグ
*/

const changeRankingTab = (parentClassName, usingParamFlg) => {
  const elementsNodes = {
    tabBackGround: document.querySelectorAll('.js-ranking-background'),
    tabList: document.querySelectorAll('.js-ranking-tabs > li'),
    rankingList: document.querySelectorAll('.js-ranking-list'),
    moreButton: document.querySelectorAll('.js-ranking-more-button')
  };

  const $elements = {
    tabBackGround: Array.prototype.slice.call(elementsNodes.tabBackGround, 0),
    tabList: Array.prototype.slice.call(elementsNodes.tabList, 0),
    rankingList: Array.prototype.slice.call(elementsNodes.rankingList, 0),
    moreButton: Array.prototype.slice.call(elementsNodes.moreButton, 0)
  };

  const config = {
    tabWidth: $elements.tabList.length > 0 ? $elements.tabList[0].clientWidth : 0,
    rankingLink: '/ranking'
  };

  function removeAllClass () {
    $elements.tabList.forEach((el) => {
      if (el.classList.contains('active')) {
        el.classList.remove('active');
      }
    });
    $elements.rankingList.forEach((el) => {
      if (el.classList.contains('active')) {
        el.classList.remove('active');
      }
    });
  }

  function addClassActive (tabIndex) {
    $elements.rankingList[tabIndex].classList.add('active');
    $elements.tabList[tabIndex].classList.add('active');
  }

  function getTabMarginRight (element) {
    const elementStyle = getComputedStyle(element, null);
    return parseInt(elementStyle.getPropertyValue('margin-right'), 10);
  }

  function addCssLeftToTab (tabIndex) {
    $elements.tabBackGround.forEach(el => {
      el.style.left = (`${config.tabWidth * tabIndex + getTabMarginRight($elements.tabList[0]) * tabIndex}px`);
    });
  }

  function addWidthToTabBackGround () {
    config.tabWidth = $elements.tabList[0].clientWidth;
    $elements.tabBackGround.forEach(el => {
      el.style.width = `${config.tabWidth}px`;
    });
  }

  function addRankingTypeToMoreButton (type) {
    const pathString = location.pathname;
    const pathWithoutLastSlash = pathString.endsWith('/') ? pathString.slice(0, -1) : pathString;
    const category = pathWithoutLastSlash.substring(pathWithoutLastSlash.lastIndexOf('/') + 1);
    const isNotCategoryPageButton = category === '';
    $elements.moreButton.forEach(el => {
      if (isNotCategoryPageButton) {
        // For TopPageButton
        el.setAttribute('href', `/ranking?type=${type}`);
      } else {
        // For CategoryPageButton
        el.setAttribute('href', `/ranking?type=${type}&category=${category}`);
      }
    });
  }

  function getIndexFromParams () {
    const index = 0;

    // Query文字列が無い時は0を返す
    if (location.search === '') {
      return index;
    }

    // Query文字列からtype={ranking_type}のranking_typeを取り出す
    const queryParams = new URLSearchParams(window.location.search);
    const rankingType = queryParams.get('type');

    // NOTE: reduce(callbackFn=(res, el, index, array) => {}, initialValue=0)
    // NOTE: 最初の呼び出しでresが指定されていない場合，array[1](=tabList[1]) となる
    // @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce
    //
    // NOTE: このreduceは(any, any, number) => number
    // NOTE: このreduceは Query type=t で指定した ランキングのtypeと
    //        ランキングのhtml要素が持つ dataset.type (e.g. day, week etc.) が一致するindexを返す
    // NOTE: つまり，遷移前に見ていたランキングのtabListの中におけるindexを返す
    // NOTE: この結果を使ってactive属性を付与する
    return $elements.tabList.reduce(
      (res, el, index) => {
        if (el.dataset.type === rankingType) {
          return index;
        } else {
          return res;
        }
      },
      0
    );
  }

  function rewriteHistory (type) {
    const url = new URL(location.href);
    const category = url.searchPrams.get('category');
    if (category === '') {
      history.replaceState('', '', `/ranking?type=${type}`);
    } else {
      history.replaceState('', '', `/ranking?type=${type}&category=${category}`);
    }
  }

  function getInitialType () {
    return $elements.tabList[0].dataset.type;
  }

  function addEventToTabs () {
    $elements.tabList.forEach((el, index) => {
      el.addEventListener('click', () => {
        removeAllClass();
        addClassActive(index);
        addCssLeftToTab(index);
        if (isMoreButtonExists()) {
          addRankingTypeToMoreButton(el.dataset.type);
        }
        if (usingParamFlg) {
          rewriteHistory(el.dataset.type);
        }
      });
    });
  }

  function isElementsExists () {
    return !!($elements.tabList.length > 0 && $elements.rankingList.length > 0);
  }

  function isTabBackGroundExists () {
    return $elements.tabBackGround.length > 0;
  }

  function isMoreButtonExists () {
    return $elements.moreButton.length > 0;
  }

  function init () {
    let rankingIndex = 0;
    if (usingParamFlg) {
      rankingIndex = getIndexFromParams();
    }
    addClassActive(rankingIndex);
    if (isTabBackGroundExists()) {
      addWidthToTabBackGround();
    }
    if (isMoreButtonExists()) {
      addRankingTypeToMoreButton(getInitialType());
    }
    addCssLeftToTab(rankingIndex);
    addEventToTabs();
  }

  function isParentElementExists () {
    return document.querySelector(`.${parentClassName}`) !== null;
  }

  if (isParentElementExists() && isElementsExists()) {
    init();
  }
};

window.addEventListener('DOMContentLoaded', () => {
  changeRankingTab('js-top-rankings', false);
  changeRankingTab('js-ranking-page', true);
});
